import {prepareElements} from '../modules/ripple';

let $elements = $('.js-field-clone-value');
let formUpdateParamsSelector = 'js-params-push-state';
let $btnLoadClass = 'btn--load';

onReadyAjax();
onSubmitFormAjax();

function onReadyAjax() {
	
	BX.addCustomEvent('onAjaxSuccess', function(e){
		
		prepareElements();
		
	});
	
}

function onSubmitFormAjax() {
	
	$(document).on('submit', 'form', function(e){
		
		let $form = $(e.target);
		
		loadBtn($form);
		updateParamsInURL($form);
		
	});
	
}

function updateParamsInURL($form) {
	
	// при отправке ajax формы обновляем параметры в URL
	
	let $formClone = $form.clone();
	$formClone.find('[name=bxajaxid], [name=AJAX_CALL]').remove();
	
	if($form.hasClass(formUpdateParamsSelector)) {
		
		BX.addCustomEvent('onAjaxSuccess', function(){
			
			let pageUrl = '?' + $formClone.serialize().replace(/\%20/g,'+');;
			window.history.pushState('', '', pageUrl);
			
		});
		
	}
	
}

function loadBtn($form){
	let $btn = $form.find('[type=submit]');
	let btnLoadClass = $btnLoadClass;

	if ($form.data('skip-loader') === true) {
		return;
	}
	
	$btn.addClass(btnLoadClass);
	
	BX.addCustomEvent('onAjaxSuccess', function handler(){
		$btn.removeClass(btnLoadClass);
		BX.removeCustomEvent('onAjaxSuccess', handler);
	});
}